import { Link } from "react-router-dom"

const ServiceTitleComponent = () => {
    return (
        <div className="about-title">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="title-text text-center">
                        <h2>Serviços</h2>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li>
                                Serviços
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceTitleComponent
